export const UPDATE_LIGHTDASH_DOCS_URL =
    'https://docs.meetsilicon.com/self-host/update-lightdash';
